<template>
	<v-sheet width="100%" class="ma-4">
		<v-card
			v-for="event in sortedEvents"
			class="mb-3"
			width="100%"
			:key="event.name"
			>
				<v-row>
					<v-col cols="12" md="10">
						<v-card-title class="font-weight-light">
							{{event.name}}
						</v-card-title>
						<v-card-text>
							{{ event.start | moment('dddd Do MMMM YYYY') }}, {{ event.start  | moment('hh:mm a') }} <span v-if="event.end"> - {{event.end  | moment('hh:mm a')}} </span>
						</v-card-text>
					</v-col>
					<v-col cols="12" md="2" >
						<v-btn class="mt-9" color="accent" @click="$emit('clickEvent', event)">More</v-btn>
					</v-col>
				</v-row>

			</v-card>
	</v-sheet>

</template>
<script type="text/javascript">    
	export default {
		name: "Agenda",
		props: {
			events: {type: Object}
		},
		computed: {
			sortedEvents(){
				return [...this.events].sort((a, b) => (a.start > b.start) ? 1 : -1)
			}
		}
	}
</script>